import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const imgUrl = (src) => {
  if (!src) return "";
  return src.startsWith("http") ? src : `${API}/files/${src}`;
};

export const getListings = async (params = {}) => {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined));
  const { data } = await client.get("/listings", { params: clean });
  return data;
};

export const getListing = async (id) => {
  const { data } = await client.get(`/listings/${id}`);
  return data;
};

export const getListingMeta = async () => {
  const { data } = await client.get("/listings/meta");
  return data;
};

export const getInsights = async (category) => {
  const { data } = await client.get("/insights", { params: category ? { category } : {} });
  return data;
};

export const getInsight = async (slug) => {
  const { data } = await client.get(`/insights/${slug}`);
  return data;
};

export const getTestimonials = async () => {
  const { data } = await client.get("/testimonials");
  return data;
};

export const postEnquiry = async (payload) => {
  const { data } = await client.post("/enquiries", payload);
  return data;
};
